<template>
  <div>
    <div v-for="(component, key) in components" v-bind:key="key">
      <ImportantInfo v-if="['Slider1', 'RestaurantMenu', 'Contact'].includes(component.component)"/>
      <Slider1 v-if="component.component === 'Slider1'"/>
      <AboutUs v-if="component.component === 'AboutUs'"/>
      <promotion1 v-if="component.component === 'promotion1'"/>
      <testimonials v-if="component.component === 'testimonials'"/>
      <RestaurantMenu v-if="component.component === 'RestaurantMenu'"/>
      <!-- Contact Start -->
      <Contact v-if="component.component === 'Contact' && $store.state.isConfigReady"/>
    </div>
  </div>
</template>

<script>
// import axiosHelper from "@/helpers/axiosHelper";
import imageMixin from "@/mixins/imageMixin";
import Testimonials from "@/views/modules/Testimonials";
import Slider1 from "@/views/modules/Slider1";
import Promotion1 from "@/views/modules/Promotion1";
import AboutUs from "@/views/modules/AboutUs";
import RestaurantMenu from "@/views/modules/RestaurantMenu";
import Contact from "@/views/Contact";
import ImportantInfo from "@/views/ImportantInfo.vue";

export default {
  name: 'Page',
  props: {
      components: Array
  },
  mixins: [imageMixin],
  components: {ImportantInfo, Contact, RestaurantMenu, AboutUs, Promotion1, Slider1, Testimonials},
}
</script>
